import { P1_CATEGORY_META } from '../../telas/painel-p1/tela8-adapter';

import type { P1Category } from '../../types';
import type React from 'react';

export interface P1CategoryBadgeProps {
  category: P1Category;
}

/** Badge de categoria P1 (.p1-cat). Enums REAIS do backend (D4). */
export function P1CategoryBadge({ category }: P1CategoryBadgeProps): React.JSX.Element | null {
  const m = P1_CATEGORY_META[category];
  if (m === undefined) return null;
  return (
    <span className={`p1-cat p1-cat--${m.tone}`}>
      <span className="p1-cat__icon" aria-hidden="true">
        {m.icon}
      </span>
      {m.label}
    </span>
  );
}
